import {
	createSlice,
} from '@reduxjs/toolkit';



const hudSlice = createSlice({
	name: 'hud',
	initialState: { user: null, loading: 'idle' },
	reducers: {
		setCurrentUser: (state, action) => {
			state.user = action.payload;
		}
		// standard reducer logic, with auto-generated action types per reducer
	},
	extraReducers: (builder) => {
		// builder.addCase(setCurrentUser, (state, action) => {
		// 	console.log("setting user!!");
		// 	console.log("state: %o, action: %o", state, action);
		// 	return { user: action.payload, loading: 'idle' };
		// });
	}
});

export const { setCurrentUser } = hudSlice.actions;
export default hudSlice.reducer; 

